export default __webpack_public_path__ + "74731692c65c36a58e7d0e3792b5c719.svg";